import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { startUsageTracking } from './utils/usageTracking'
import {
  startErrorReporting,
  installGlobalErrorHandlers,
} from './utils/errorReporter'

const app = createApp(App)

app.use(router)
app.use(store)
app.use(vuetify)

startUsageTracking({ router, store })
startErrorReporting({ router, store })
installGlobalErrorHandlers(app)

app.mount('#app')
